import PalletsTransferHistory from 'components/PalletsTransferHistory/PalletsTransferHistory';
import WithAuth from 'hoc/withAuth';

const PalletsTransferHistoryPage = () => <PalletsTransferHistory mode="ROLE_CLIENT" />;

export default WithAuth(PalletsTransferHistoryPage, 'ROLE_CLIENT');
